import { combineEpics } from 'redux-observable';
import {
  fetchMedicationHistoryEpic,
  fetchProviderOrderEpic,
  revokeProviderOrderEpic,
  addIssueToProviderOrderEpic,
  fetchInteractionAlertEpic,
  postPatientWeightFormEpic,
  validatePatientWeightFormEpic,
  fetchFormularyDrugEpic,
  fetchPrescriptionBenefitsEpic,
  fetchEligibilityEpic,
  submitPrescriptionFormEpic,
  resubmitPrescriptionFormEpic,
  fetchQuickRxByProviderEpic,
  postQuickRxFormEpic,
  postRemoveQuickRxFormEpic,
  fetchMedicationInfoEpic,
  fetchMedicationFormEpic,
  fetchCommonDosageEpic,
  fetchMedicationBySpecialityEpic,
  fetchPrescriptionCodeEpic,
  confirmPendingPrescriptionsListEpic,
  refetchPrescriptionFormEpic,
  submitPrescriptionsPostConsultEpic,
  submitPrescriptionsPostConsultSuccessEpic,
  revokeProviderOrderSuccessEpic,
  revokeProviderOrderFailEpic,
  fetchClinicalAllergyEpic
} from 'medication_service_ui';
import rteTestEpic from '../RteTestComponent/epics';
import {
  fetchClinicalMedEpic,
  refetchClinicalMedEpic,
  fetchMedicationListEpic
} from '../clinical-medication/epics';

import {
  filterIncentiveCosts,
  fetchProvidersForIncentiveCostRequest,
  createManyIncentivesRequests,
  finishManyIncentivesRequests,
  deleteIncentiveCostRequest,
  toggleProviderInclusionInIncentive
} from '../provider-incentive/provider-incentive-cost/epics';

import providerSurgeIncentiveEpics from '../provider-incentive/provider-surge-incentive/epics';

import { searchProvidersEpic } from '../provider-search/epics';

import consultQueueEpics from '../consult-queue/epics';

import { editPayerEpic, restorePayerVersionEpic } from '../EditPayer/epics';

import {
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic,
  importExternalGroupRelationEpic
} from '../external_group_relations/epics';


import {
  fetchMultiContractRelationEpic,
  createMultiContractOrgRelationEpic,
  searchBenefitSponsorContractRelationsEpic
} from '../multi_contract_org_relations/epics';

import surescriptsInformationEpics from '../surescripts-information/epics';

import { emrEpics } from '@td/emr';

import emrManagerEpics from '../GrantRevokeEmrManagerRole/redux/epics'

export default combineEpics(
  rteTestEpic,
  fetchClinicalMedEpic,
  fetchMedicationHistoryEpic,
  fetchProviderOrderEpic,
  revokeProviderOrderEpic,
  addIssueToProviderOrderEpic,
  fetchInteractionAlertEpic,
  postPatientWeightFormEpic,
  validatePatientWeightFormEpic,
  fetchFormularyDrugEpic,
  fetchPrescriptionBenefitsEpic,
  fetchEligibilityEpic,
  submitPrescriptionFormEpic,
  resubmitPrescriptionFormEpic,
  fetchQuickRxByProviderEpic,
  postQuickRxFormEpic,
  postRemoveQuickRxFormEpic,
  fetchMedicationInfoEpic,
  fetchMedicationFormEpic,
  fetchCommonDosageEpic,
  fetchMedicationBySpecialityEpic,
  fetchPrescriptionCodeEpic,
  confirmPendingPrescriptionsListEpic,
  refetchPrescriptionFormEpic,
  submitPrescriptionsPostConsultEpic,
  submitPrescriptionsPostConsultSuccessEpic,
  revokeProviderOrderSuccessEpic,
  revokeProviderOrderFailEpic,
  refetchClinicalMedEpic,
  fetchClinicalAllergyEpic,
  filterIncentiveCosts,
  fetchProvidersForIncentiveCostRequest,
  createManyIncentivesRequests,
  finishManyIncentivesRequests,
  deleteIncentiveCostRequest,
  toggleProviderInclusionInIncentive,
  providerSurgeIncentiveEpics,
  searchProvidersEpic,
  consultQueueEpics,
  editPayerEpic,
  restorePayerVersionEpic,
  fetchExternalGroupRelationsEpic,
  deleteExternalGroupRelationEpic,
  updateExternalGroupRelationEpic,
  createExternalGroupRelationEpic,
  fetchGroupsEpic,
  importExternalGroupRelationEpic,
  surescriptsInformationEpics,
  emrEpics,
  fetchMultiContractRelationEpic,
  createMultiContractOrgRelationEpic,
  searchBenefitSponsorContractRelationsEpic,
  emrManagerEpics,
  fetchMedicationListEpic
);
